module.exports = __webpack_public_path__ + "img/close-btn.c6003073.svg";